import {maxBy} from "lodash";
import {PartnerDetails, Vehicle} from "../../types";
import { datadogRum } from "@datadog/browser-rum";
type HandlePromoParams = {
    commonBenefits: any;
    partnerDetails: PartnerDetails;
    serviceRequest: any;
    tireChangeServiceDetails?: any;
    serviceRequestPayload: any;
}

const getHighestCoveragePromoCode = (vehicles?: Vehicle[]) =>
  maxBy(
    vehicles?.filter((v) => v.suspendIndicator !== 'Y' &&
        !!v.promotionCode),
    (v: Vehicle) => parseFloat(v.coverageAmount)
  )?.promotionCode;

  export const handlePromoCode = ({ commonBenefits, partnerDetails, serviceRequest, tireChangeServiceDetails,serviceRequestPayload }: HandlePromoParams): any | undefined => {
  const coverageFollowsVehicle = partnerDetails?.experience?.coverageFollowsVehicle;
  const addAVehicle = partnerDetails?.experience?.addAVehicle;
  const vehiclePromo = serviceRequest?.vehicles?.promotionCode;
  const isTireService = serviceRequest?.serviceTypeOptions?.tire;
  const isJumpStartService = serviceRequest?.serviceTypeOptions?.battery;

  if (!commonBenefits?.benefits || commonBenefits?.noBenefits || serviceRequest?.loggedIn === 'N') {

    if(serviceRequestPayload.promoCode!= partnerDetails?.promoCode){
      datadogRum.addAction("PPU Policy Eligibility", {
        ppuEligibilityReason:"swiched_to_PPU",
        partnerCode: partnerDetails?.partnerCode,
        callId: serviceRequestPayload?.sessionId,
      });
    }
    return partnerDetails?.promoCode;
  }

  if (coverageFollowsVehicle && vehiclePromo)
      return vehiclePromo;

  if (coverageFollowsVehicle && addAVehicle && !vehiclePromo) {
      const promoCode = getHighestCoveragePromoCode(commonBenefits?.vehicles);
      if (!promoCode)
        datadogRum.addError(new Error("No valid promo code found for coverageFollowsVehicle experience and adding new vehicle"), {
          partnerCode: partnerDetails?.partnerCode,
          usageId: commonBenefits?.usageId,
          addAVehicle: addAVehicle,
          vehiclePromo: vehiclePromo,
          coverageFollowsVehicle: coverageFollowsVehicle,
        });
      return promoCode
  }

/**
 * Walmart partner: when a user has both standard and enhanced benefits,
 * tire change and jumpstart services use Promocode from serviceRequest.
 * All other services use commonBenefits Promocode.
 */
  if(tireChangeServiceDetails?.additionalCoverage) {
    const promoCode = (isTireService || isJumpStartService) ? serviceRequest?.promoCode : commonBenefits.promoCode;
    return promoCode;
  }

}
